/**
 * RESPONSIBILITY: the Children's Ministry page's team band.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { Person } from '../commons/rows/person';

@Section({ name: SectionName.ChildrenTeam, label: 'Children — who leads it' })
export class ChildrenTeamSection {
  @Text({ label: 'Title', maxLength: 120, default: 'Who leads it' })
  teamHeading!: string;

  @List({ label: 'Team', of: () => Person, maxItems: 12 })
  team!: Person[];
}
